// extracted by mini-css-extract-plugin
module.exports = {"iframe":"PayPalPayflowProvider_iframe__3DYuo","iframeSpacer":"PayPalPayflowProvider_iframeSpacer__2NdK9"};